import React, { useEffect, useRef, useState } from "react";
import "./FloatingActions.css";

const SUPPORT_PHONE = "18002104422";
const WHATSAPP_NUMBER = "18002104422";

export default function FloatingActions() {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const closeActions = () => {
    setOpen(false);
  };

  return (
    <div
      ref={containerRef}
      className={`floating-actions-container ${open ? "open" : ""}`}
    >
      <div
        id="floating-action-menu"
        className="floating-actions-menu"
        aria-hidden={!open}
      >
        <a
          href={`tel:+${SUPPORT_PHONE}`}
          className="floating-action-item floating-action-call"
          aria-label="Call Monayra"
          title="Call Now"
          onClick={closeActions}
        >
          <span className="floating-action-tooltip">
            Call Now
          </span>

          <span className="floating-action-icon">
            <i className="bi bi-telephone-fill"></i>
          </span>
        </a>

        <a
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
            "Hello Monayra, I would like assistance regarding a loan."
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-action-item floating-action-whatsapp"
          aria-label="Chat with Monayra on WhatsApp"
          title="WhatsApp"
          onClick={closeActions}
        >
          <span className="floating-action-tooltip">
            WhatsApp
          </span>

          <span className="floating-action-icon">
            <i className="bi bi-whatsapp"></i>
          </span>
        </a>

        <a
          href={`sms:+${SUPPORT_PHONE}?body=${encodeURIComponent(
            "Hello Monayra, I would like assistance regarding a loan."
          )}`}
          className="floating-action-item floating-action-message"
          aria-label="Send a message to Monayra"
          title="Send Message"
          onClick={closeActions}
        >
          <span className="floating-action-tooltip">
            Message
          </span>

          <span className="floating-action-icon">
            <i className="bi bi-chat-dots-fill"></i>
          </span>
        </a>
      </div>

      <button
        type="button"
        className="floating-actions-main"
        onClick={() => setOpen((currentState) => !currentState)}
        aria-label={open ? "Close quick actions" : "Open quick actions"}
        aria-expanded={open}
        aria-controls="floating-action-menu"
      >
        <span className="floating-actions-main-icon">
          <i
            className={
              open
                ? "bi bi-x-lg"
                : "bi bi-grid-fill"
            }
          ></i>
        </span>

        <span className="floating-actions-pulse"></span>
      </button>
    </div>
  );
}